import { CpsUiAdminConfigType } from '@cs-cms/types';

export const uiAdminConfigsKeys = {
  all: ['uiAdminConfigs'] as const,
  uiAdminConfigByKey: (key?: CpsUiAdminConfigType) => [...uiAdminConfigsKeys.all, 'entry', key] as const,
  uiAdminConfigWritePermissions: (keys?: string[]) => [...uiAdminConfigsKeys.all, 'writePermissions', keys] as const
};
